import Checkbox from "antd/lib/checkbox/Checkbox";
import { useDispatch } from "react-redux";
import { Row, Col, Input } from "antd";
import { handleHiddenStiBonuses, handleOfferModeller } from "@store/offers";
import { ReactComponent as PlusIcon } from "@assets/images/plus-with-bg.svg";
import { useTypedSelector } from "@hooks";

import { calculatePercentageAmount, getCurrencyTotal, round } from "@utils";
import {
  offersApi,
  useFetchComparatorDataQuery,
  useFetchOfferCurrencyRateQuery,
} from "@services";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { formatNumberWithCommas } from "@/utils/formatNumberWithCommas";
import { currenciesConverter, calculatePropose } from "@utils";

const ShortTermIncentives = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const isRevised = search === "?mode=revise";
  const {
    offerModeller: { offer_sti, offer_fixed_cash },
    currencyRate,
    currencyName,
    offer,
    hidden_sti_bonuses,
    offerCurrency,
    currentCandidateCurrency,
  } = useTypedSelector(state => state.offers);
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const {
    data: counrtyList,
    error,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    refetch,
  } = useFetchOfferCurrencyRateQuery(
    {
      code: offer?.offer_candidate_detail?.currency?.id,
      company_id,
      offer_id: offer?.id,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: !offer?.offer_candidate_detail?.currency?.id,
    }
  );
  const { data } = useFetchComparatorDataQuery(
    {
      company_id,
      offer_id: offer?.id,
    },
    { skip: !offer?.id }
  );

  const currentTargetCashDifference =
    (offer_fixed_cash?.current_total || 0) +
    (offer_sti?.current_total_bonus || 0);

  const { data: comparatorData } = data || {};

  let id = comparatorData?.currency?.market_currency?.id;

  useEffect(() => {
    if (!id) return;
    if (id != offer?.offer_position_detail?.currency?.id) {
      dispatch(
        offersApi.endpoints.fetchStiCurrencyRate.initiate(
          {
            code: id,
            company_id,
            offer_id: offer?.id,
          },
          {
            subscribe: false,
            forceRefetch: true,
          }
        )
      );

      // updateNew();
    }
  }, [id]);

  const purposoeTargetCashDifference = Math.round(
    offer_sti?.is_sale_incentive &&
      offer_fixed_cash?.proposed_annual_base &&
      offer_sti?.proposed_base_pay_percentage
      ? (offer_fixed_cash.proposed_annual_base *
        ((offer_fixed_cash.proposed_annual_base *
          (100 - offer_sti.proposed_base_pay_percentage)) /
          100)) /
      ((offer_fixed_cash.proposed_annual_base *
        offer_sti.proposed_base_pay_percentage) /
        100) -
      offer_sti.proposed_base_pay_percentage +
      ((offer_sti?.proposed_total_bonus || 0) +
        (offer_fixed_cash?.proposed_total || 0))
      : (offer_sti?.proposed_total_bonus || 0) +
      (offer_fixed_cash?.proposed_total || 0)
  );

  const currCashDifference = currenciesConverter(
    counrtyList?.data?.result || 1,
    purposoeTargetCashDifference
  );

  const targetCashDifference = calculatePropose(
    currentTargetCashDifference,
    currCashDifference
  );

  const currencyCode = currencyName?.split("(")[1]?.replace(")", "") || "";

  const currRa = currenciesConverter(
    counrtyList?.data?.result || 1,
    offer_sti?.proposed_total_bonus
  );

  const totalBonusDifference = calculatePropose(
    offer_sti?.current_total_bonus,
    currRa
  );

  const current_bonus_target_amount =
    offer_fixed_cash?.current_annual_base && offer_sti?.current_bonus_target
      ? round(
        (offer_fixed_cash?.current_annual_base *
          offer_sti?.current_bonus_target) /
        100
      )
      : "";
  const proposed_bonus_target_amount =
    offer_fixed_cash?.proposed_annual_base && offer_sti?.proposed_bonus_target
      ? round(
        (offer_fixed_cash?.proposed_annual_base *
          offer_sti?.proposed_bonus_target) /
        100
      )
      : "";

  const readOnly =
    offer && offer?.status !== "DRAFTED" && !isRevised ? true : false;
  const labelColSpan = currencyCode ? 10 : 12;
  const currencyColSpan = currencyCode ? 7 : 12;

  const { proposed_currency_total } = getCurrencyTotal(
    {
      ...offer_sti,
      current_bonus_target: current_bonus_target_amount,
      proposed_bonus_target: proposed_bonus_target_amount,
    },
    currencyRate,
    ["proposed_base_pay_percentage"]
  );
  const { current_currency_total } = getCurrencyTotal(
    {
      ...offer_sti,
      current_bonus_target: current_bonus_target_amount,
      proposed_bonus_target: proposed_bonus_target_amount,
    },
    currentCandidateCurrency,
    ["proposed_base_pay_percentage"]
  );

  const handleChange = (event?: any) => {
    const cleanedValue = event?.target?.value?.replace(/,/g, "");
    dispatch(
      handleOfferModeller({
        key: "offer_sti",
        data: {
          [event.target.name]: +cleanedValue || null,
        },
      })
    );
  };

  const addMoreLocally = (is_current: boolean) => {
    const newCurrent = {
      is_current,
      value: null,
      name: null,
      id: +_.uniqueId(),
      readonly: true,
    };
    dispatch(
      handleOfferModeller({
        key: "offer_sti",
        data: {
          bonuses: [...offer_sti?.bonuses, newCurrent],
        },
      })
    );
  };

  const handleChangeNewField = (
    id: number,
    value: number | string,
    type: "name" | "value"
  ) => {
    dispatch(
      handleOfferModeller({
        key: "offer_sti",
        data: {
          bonuses: offer_sti?.bonuses?.map(bonus =>
            bonus?.id === id ? { ...bonus, [type]: value } : bonus
          ) as any,
        },
      })
    );
  };

  const handleChangeNewFieldForPurpose = (
    id: number,
    value: number,
    type: "value",
    basePay?: number
  ) => {
    dispatch(
      handleOfferModeller({
        key: "offer_sti",
        data: {
          bonuses: offer_sti?.bonuses?.map(bonus => {
            if (bonus.id !== id) return bonus;

            const calculatedValue =
              bonus?.is_percentage && basePay ? basePay * (value / 100) : value;

            return {
              ...bonus,
              value,
              original_value: calculatedValue,
            };
          }) as any,
        },
      })
    );
  };
  const removeField = (id: number) => {
    dispatch(
      handleOfferModeller({
        key: "offer_sti",
        data: {
          bonuses: offer_sti?.bonuses?.map(bonus =>
            bonus?.id === id ? { ...bonus, readonly: false } : bonus
          ) as any,
        },
      })
    );
  };

  const removeBonus = (id: number) => {
    dispatch(
      handleOfferModeller({
        key: "offer_sti",
        data: {
          bonuses: offer_sti?.bonuses?.filter(bonus => bonus?.id !== id) as any,
        },
      })
    );
  };

  const proposedTotal =
    (offer_fixed_cash?.proposed_total || 0) +
    (offer_sti?.proposed_total_bonus || 0);
  const currentTotal =
    (offer_fixed_cash?.current_total || 0) +
    (offer_sti?.current_bonus_target || 0);

  let percentageDifference = 0;
  const finalPercentage =
    percentageDifference > 0 ? percentageDifference.toFixed(0) : 0;

  if (proposedTotal > 0 && currentTotal > 0) {
    percentageDifference = (proposedTotal / currentTotal - 1) * 100;
  }

  return (
    <>
      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__header-row cursor-pointer rounded-l-md  bg-revampLightBlueBackground">
            <Col span={12}>
              <div className="sub-heading font-semibold text-lg">Current</div>
            </Col>
          </Row>
          <Row className="salary-offer__content-row mt-5">
            {/* Current-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field-upper" />

              <div className="salary-offer__content-row__field">
                <label>Bonus Target %</label>
              </div>

              <div className="salary-offer__content-row__field">
                <label>Bonus Target Amount</label>
              </div>
              <div className="salary-offer__content-row__field">
                <label>Bonus Actual Amount</label>
              </div>

              <div className="salary-offer__content-row__field">
                <label>
                  <Checkbox
                    checked={offer_sti?.is_current_sale_incentive}
                    disabled={readOnly}
                    onChange={e => {
                      dispatch(
                        handleOfferModeller({
                          key: "offer_sti",
                          data: {
                            is_current_sale_incentive: e.target.checked,

                            current_actual_bonus_amount: null,
                            current_bonus_target_amount: null,
                            current_bonus_target: null,
                            current_actual_sales_incentive: null,
                            current_sale_incentive: null,

                            // !e.target.checked
                            // proposed_bonus_target: null,
                            // proposed_base_pay_percentage:
                            //   !e.target.checked && null,
                          },
                        })
                      );
                      setTimeout(() => {
                        dispatch(
                          handleOfferModeller({
                            key: "offer_sti",
                            data: {
                              current_total_bonus: 0,
                            },
                          })
                        );
                      }, 100);
                      // dispatch(
                      //   handleHiddenStiBonuses(
                      //     e.target.checked
                      //       ? offer_sti?.bonuses?.filter(
                      //           bonus => bonus?.auto_populate
                      //         )
                      //       : []
                      //   )
                      // );
                    }}
                  >
                    Sales Incentive
                  </Checkbox>
                </label>
              </div>
              <div className="salary-offer__content-row__field">
                <label>Target Sales Incentive</label>
              </div>
              <div className="salary-offer__content-row__field">
                <label>Actual Sales Incentive</label>
              </div>
              {offer_sti?.bonuses
                ?.filter(({ is_current }) => is_current)
                ?.map(({ name, id, readonly }) => (
                  <div key={id} className="salary-offer__content-row__field">
                    {name?.length && !readonly! ? (
                      <label>{name}</label>
                    ) : (
                      <Input
                        readOnly={readOnly}
                        autoFocus
                        onChange={e =>
                          handleChangeNewField(id!, e?.target?.value, "name")
                        }
                        onKeyDown={e => {
                          if (e.key === "Enter") {
                            removeField(id!);
                          }
                        }}
                        value={name || ""}
                        placeholder="Value here..."
                        size="large"
                      />
                    )}
                    {!readOnly && (
                      <div
                        className="salary-offer__content-row__field__remove"
                        onClick={() => removeBonus(id!)}
                      >
                        <PlusIcon fill="#000" />
                      </div>
                    )}
                  </div>
                ))}

              {!readOnly ? (
                <div
                  onClick={() => addMoreLocally(true)}
                  className="salary-offer__content-row__field--add-more"
                >
                  <PlusIcon fill="#FF9560" />
                  <span>Add more</span>
                </div>
              ) : (
                <div className="salary-offer__content-row__field--add-more" />
              )}
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field-upper">
                {offer?.offer_candidate_detail?.currency?.code}
              </div>

              <div className="salary-offer__content-row__field">
                <Input
                  readOnly={readOnly}
                  type="text"
                  disabled={offer_sti?.is_current_sale_incentive}
                  name="current_bonus_target"
                  onChange={handleChange}
                  value={formatNumberWithCommas(
                    offer_sti?.current_bonus_target || ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div>
              <div className="salary-offer__content-row__field">
                <Input
                  readOnly
                  type="text"
                  disabled={offer_sti?.is_current_sale_incentive}
                  value={formatNumberWithCommas(
                    current_bonus_target_amount || ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div>
              {/* Add this field for Bonus Actual Amount*/}
              {/* <div className="salary-offer__content-row__field">
                <Input
                  readOnly
                  type="text"
                  value={formatNumberWithCommas(
                    current_bonus_target_amount || ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div> */}

              {/* Add this field for Bonus Actual Amount*/}
              <div className="salary-offer__content-row__field">
                <Input
                  readOnly={readOnly}
                  type="text"
                  name="current_actual_bonus_amount"
                  disabled={offer_sti.is_current_sale_incentive}
                  value={formatNumberWithCommas(
                    offer_sti?.current_actual_bonus_amount || ""
                  )}
                  onChange={handleChange}
                  placeholder="Value here..."
                  size="large"
                />
              </div>

              <div className="salary-offer__content-row__field"></div>
              <div className="salary-offer__content-row__field">
                <Input
                  readOnly={readOnly}
                  type="text"
                  name="current_sale_incentive"
                  disabled={!offer_sti.is_current_sale_incentive}
                  value={formatNumberWithCommas(
                    offer_sti?.current_sale_incentive || ""
                  )}
                  onChange={handleChange}
                  placeholder="Value here..."
                  size="large"
                />
              </div>
              {/* Add this field for Actual Sales Incentive*/}
              <div className="salary-offer__content-row__field">
                <Input
                  readOnly={readOnly}
                  type="text"
                  name="current_actual_sales_incentive"
                  disabled={!offer_sti.is_current_sale_incentive}
                  value={formatNumberWithCommas(
                    offer_sti?.current_actual_sales_incentive || ""
                  )}
                  // value={formatNumberWithCommas(
                  //   offer_sti?.current_sale_incentive || ""
                  // )}
                  onChange={handleChange}
                  placeholder="Value here..."
                  size="large"
                />
              </div>

              {offer_sti?.bonuses
                ?.filter(({ is_current }) => is_current)
                ?.map(({ name, value, id }) => (
                  <div key={id} className="salary-offer__content-row__field">
                    <Input
                      readOnly={readOnly}
                      name={name!}
                      type="text"
                      value={formatNumberWithCommas(value) || ""}
                      onChange={e =>
                        handleChangeNewField(
                          id!,
                          +e.target.value.replace(/,/g, ""),
                          "value"
                        )
                      }
                      placeholder="Value here..."
                      size="large"
                    />
                  </div>
                ))}

              <div className="salary-offer__content-row__field--add-more" />
            </Col>
            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field-upper">
                  {currencyCode}
                </div>
                <div className="salary-offer__content-row__field"></div>
                <div className="salary-offer__content-row__field">
                  <Input
                    type="text"
                    value={formatNumberWithCommas(
                      current_bonus_target_amount
                        ? round(
                          current_bonus_target_amount *
                          currentCandidateCurrency!
                        ) || ""
                        : ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>

                <div className="salary-offer__content-row__field">
                  <Input
                    type="text"
                    value={formatNumberWithCommas(
                      round(
                        offer_sti?.current_actual_bonus_amount! *
                        currentCandidateCurrency!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>
                <div className="salary-offer__content-row__field"></div>
                <div className="salary-offer__content-row__field">
                  <Input
                    type="text"
                    value={formatNumberWithCommas(
                      round(
                        offer_sti?.current_sale_incentive! *
                        currentCandidateCurrency!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>
                <div className="salary-offer__content-row__field">
                  <Input
                    type="text"
                    value={formatNumberWithCommas(
                      round(
                        offer_sti?.current_actual_sales_incentive! *
                        currentCandidateCurrency!
                      ) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>
                {offer_sti?.bonuses
                  ?.filter(({ is_current }) => is_current)
                  ?.map(({ id, value }) => (
                    <div key={id} className="salary-offer__content-row__field">
                      <Input
                        type="text"
                        value={formatNumberWithCommas(
                          round(value! * currentCandidateCurrency!) || ""
                        )}
                        readOnly
                        placeholder="Value here..."
                        size="large"
                      />
                    </div>
                  ))}

                <div className="salary-offer__content-row__field--add-more" />
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__header-row cursor-pointer rounded-r-md bg-revampLightBlueBackground">
            <Col span={12}>
              <div className="sub-heading font-semibold text-lg">Proposed</div>
            </Col>
          </Row>
          <Row className="salary-offer__content-row mt-5">
            {/* Proposed-Cols */}
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field-upper"></div>
              <div className="salary-offer__content-row__field">
                <label>Bonus Target %</label>
              </div>

              <div className="salary-offer__content-row__field">
                <label>Bonus Target Amount</label>
              </div>

              <div className="salary-offer__content-row__field">
                <label>
                  <Checkbox
                    checked={offer_sti?.is_sale_incentive}
                    disabled={readOnly}
                    onChange={e => {
                      dispatch(
                        handleOfferModeller({
                          key: "offer_sti",
                          data: {
                            is_sale_incentive: e.target.checked,

                            proposed_bonus_target: null,
                            proposed_base_pay_percentage:
                              !e.target.checked && null,
                          },
                        })
                      );
                    }}
                  >
                    Sales Incentive
                  </Checkbox>
                </label>
              </div>
              <div
                className={`salary-offer__content-row__field salary-offer__content-row__field--nested ${offer_sti?.is_sale_incentive ? "visible" : ""
                  }`}
              >
                <label>Annual Base Pay:</label>
              </div>
              <div
                className={`salary-offer__content-row__field salary-offer__content-row__field--nested ${offer_sti?.is_sale_incentive ? "visible" : ""
                  }`}
              >
                <label>Base Pay %:</label>
              </div>
              <div
                className={`salary-offer__content-row__field salary-offer__content-row__field--nested ${offer_sti?.is_sale_incentive ? "visible" : ""
                  }`}
              >
                <label>Incentive %:</label>
              </div>
              <div
                className={`salary-offer__content-row__field salary-offer__content-row__field--nested ${offer_sti?.is_sale_incentive ? "visible" : ""
                  }`}
              >
                <label>Sales Incentive Payout:</label>
              </div>

              {offer_sti?.bonuses
                ?.filter(({ is_current }) => !is_current)
                ?.map(({ name, id, readonly }) => (
                  <div key={id} className="salary-offer__content-row__field">
                    {name?.length && !readonly! ? (
                      <label>{name}</label>
                    ) : (
                      <Input
                        readOnly={readOnly}
                        autoFocus
                        onChange={e =>
                          handleChangeNewField(id!, e?.target?.value, "name")
                        }
                        onKeyDown={e => {
                          if (e.key === "Enter") {
                            removeField(id!);
                          }
                        }}
                        value={name || ""}
                        placeholder="Value here..."
                        size="large"
                      />
                    )}
                    {!readOnly && (
                      <div
                        className="salary-offer__content-row__field__remove"
                        onClick={() => removeBonus(id!)}
                      >
                        <PlusIcon fill="#000" />
                      </div>
                    )}
                  </div>
                ))}

              {!readOnly ? (
                <div
                  onClick={() => addMoreLocally(false)}
                  className="salary-offer__content-row__field--add-more"
                >
                  <PlusIcon fill="#FF9560" />
                  <span>Add more</span>
                </div>
              ) : (
                <div className="salary-offer__content-row__field--add-more" />
              )}
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field-upper">
                {offer?.offer_position_detail?.currency?.code}
              </div>
              <div className="salary-offer__content-row__field">
                <Input
                  disabled={offer_sti?.is_sale_incentive}
                  type="text"
                  readOnly={readOnly}
                  name="proposed_bonus_target"
                  onChange={handleChange}
                  value={formatNumberWithCommas(
                    offer_sti?.proposed_bonus_target || ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div>
              <div className="salary-offer__content-row__field">
                <Input
                  readOnly
                  disabled={offer_sti?.is_sale_incentive}
                  type="text"
                  value={formatNumberWithCommas(
                    proposed_bonus_target_amount || ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div>
              <div className="salary-offer__content-row__field" />
              <div
                className={`${offer_sti?.is_sale_incentive ? "visible" : ""
                  } salary-offer__content-row__field salary-offer__content-row__field--nested`}
              >
                <Input
                  type="text"
                  disabled={!offer_sti?.is_sale_incentive}
                  contentEditable={offer_sti?.is_sale_incentive}
                  readOnly={readOnly}
                  onChange={event => {
                    const val = +event.target.value.replace(/,/g, "");
                    dispatch(
                      handleOfferModeller({
                        key: "offer_fixed_cash",
                        data: {
                          proposed_annual_base: val || null,
                          proposed_compa_ratio:
                            (comparatorData?.internal_comparator_data
                              ?.internal_salary_range?.mid &&
                              val &&
                              (offerCurrency != null
                                ? val * offerCurrency
                                : val) /
                              comparatorData?.internal_comparator_data
                                ?.internal_salary_range?.mid) ||
                            null,

                          proposed_market_ratio:
                            comparatorData?.external_comparator_data
                              ?.market_data_grade?.p50 && val
                              ? (offerCurrency != null
                                ? val * offerCurrency
                                : val) /
                              (comparatorData?.external_comparator_data
                                ?.market_data_grade_function?.p50 ||
                                comparatorData?.external_comparator_data
                                  ?.market_data_grade?.p50)
                              : null,
                        },
                      })
                    );

                    dispatch(
                      handleOfferModeller({
                        key: "offer_fixed_cash",
                        data: {
                          allowances: offer_fixed_cash?.allowances?.map(
                            allowance => {
                              return allowance?.is_percentage
                                ? {
                                  ...allowance,
                                  value: allowance?.percentage
                                    ? (val * allowance?.percentage) / 100
                                    : val,
                                }
                                : allowance;
                            }
                          ),
                        },
                      })
                    );

                    dispatch(
                      handleOfferModeller({
                        key: "offer_sti",
                        data: {
                          bonuses: offer_sti?.bonuses?.map(bonus => {
                            return bonus?.is_percentage && bonus?.is_basic_pay
                              ? {
                                ...bonus,
                                value: bonus?.percentage
                                  ? (val * bonus?.percentage) / 100
                                  : val,
                              }
                              : bonus?.is_percentage && !bonus?.is_basic_pay
                                ? {
                                  ...bonus,
                                  value: bonus?.percentage
                                    ? (offer_fixed_cash?.proposed_total *
                                      bonus?.percentage) /
                                    100
                                    : val,
                                }
                                : bonus;
                          }),
                        },
                      })
                    );
                  }}
                  value={formatNumberWithCommas(
                    offer_fixed_cash?.proposed_annual_base || ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div>
              <div
                className={`${offer_sti?.is_sale_incentive ? "visible" : ""
                  } salary-offer__content-row__field salary-offer__content-row__field--nested`}
              >
                <Input
                  disabled={!offer_sti?.is_sale_incentive}
                  contentEditable={offer_sti?.is_sale_incentive}
                  type="text"
                  name="proposed_base_pay_percentage"
                  value={formatNumberWithCommas(
                    offer_sti?.proposed_base_pay_percentage || ""
                  )}
                  onChange={handleChange}
                  placeholder="Value here..."
                  readOnly={readOnly}
                  size="large"
                />
              </div>
              <div
                className={`${offer_sti?.is_sale_incentive ? "visible" : ""
                  } salary-offer__content-row__field salary-offer__content-row__field--nested`}
              >
                <Input
                  type="text"
                  readOnly
                  disabled={!offer_sti?.is_sale_incentive}
                  contentEditable={offer_sti?.is_sale_incentive}
                  value={formatNumberWithCommas(
                    offer_sti?.proposed_base_pay_percentage
                      ? 100 - offer_sti?.proposed_base_pay_percentage
                      : ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div>
              <div
                className={`${offer_sti?.is_sale_incentive ? "visible" : ""
                  } salary-offer__content-row__field salary-offer__content-row__field--nested`}
              >
                <Input
                  type="text"
                  readOnly
                  disabled={!offer_sti?.is_sale_incentive}
                  contentEditable={offer_sti?.is_sale_incentive}
                  value={formatNumberWithCommas(
                    offer_fixed_cash?.proposed_annual_base &&
                      offer_sti?.proposed_base_pay_percentage
                      ? round(
                        (offer_fixed_cash?.proposed_annual_base *
                          ((offer_fixed_cash?.proposed_annual_base *
                            (100 - offer_sti?.proposed_base_pay_percentage)) /
                            100)) /
                        ((offer_fixed_cash?.proposed_annual_base *
                          offer_sti?.proposed_base_pay_percentage) /
                          100)
                      ) || ""
                      : ""
                  )}
                  placeholder="Value here..."
                  size="large"
                />
              </div>

              {/* Comment by areeb */}
              {/* <div className="salary-offer__content-row__field"></div> */}
              {/* khurram sti issue  */}
              {offer_sti?.bonuses
                ?.filter(({ is_current }) => !is_current)
                ?.map(
                  ({
                    name,
                    value,
                    id,
                    is_percentage,
                    original_value,
                    is_basic_pay,
                  }: any) => {
                    return (
                      <div
                        key={id}
                        className="salary-offer__content-row__field"
                      >
                        <Input
                          name={name!}
                          readOnly={readOnly || is_percentage}
                          type="text"
                          value={
                            is_percentage
                              ? formatNumberWithCommas(
                                is_basic_pay
                                  ? calculatePercentageAmount(
                                    Number(
                                      offer_fixed_cash?.proposed_annual_base
                                    ),
                                    original_value
                                  )
                                  : calculatePercentageAmount(
                                    Number(
                                      offer_fixed_cash?.proposed_total
                                    ),
                                    original_value
                                  )
                              )
                              : formatNumberWithCommas(round(value) || "")
                          }
                          // value={
                          //   is_percentage
                          //     ? formatNumberWithCommas(
                          //         is_basic_pay
                          //           ? calculatePercentageAmount(
                          //               Number(
                          //                 offer_fixed_cash?.proposed_annual_base
                          //               ),
                          //               value
                          //             )
                          //           : calculatePercentageAmount(
                          //               Number(
                          //                 offer_fixed_cash?.proposed_total
                          //               ),
                          //               value
                          //             )
                          //       )
                          //     : formatNumberWithCommas(round(value))
                          // }
                          onChange={e => {
                            if (!is_percentage) {
                              handleChangeNewField(
                                id!,
                                +e.target.value.replace(/,/g, ""),
                                "value"
                              );
                            }
                          }}
                          size="large"
                        />
                      </div>
                    );
                  }
                )}

              <div className="salary-offer__content-row__field--add-more" />
            </Col>
            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field-upper">
                  {currencyCode}
                </div>
                <div className="salary-offer__content-row__field"></div>
                <div className="salary-offer__content-row__field">
                  <Input
                    value={formatNumberWithCommas(
                      proposed_bonus_target_amount
                        ? round(proposed_bonus_target_amount * currencyRate!) ||
                        ""
                        : ""
                    )}
                    type="text"
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>

                <div className="salary-offer__content-row__field" />
                <div className="salary-offer__content-row__field" />
                <div className="salary-offer__content-row__field" />
                <div className="salary-offer__content-row__field" />
                <div className="salary-offer__content-row__field" />

                {offer_sti?.bonuses
                  ?.filter(({ is_current }) => !is_current)
                  ?.map(
                    ({
                      id,
                      value,
                      is_percentage,
                      is_basic_pay,
                      original_value,
                    }) => {
                      // let updatedVal =
                      //   is_percentage && offer_fixed_cash?.proposed_annual_base
                      //     ? round(value)
                      //     : !is_percentage
                      //       ? round(value) || 0
                      //       : 0;

                      let updatedVal = is_percentage
                        ? is_basic_pay
                          ? calculatePercentageAmount(
                            Number(offer_fixed_cash?.proposed_annual_base),
                            Number(original_value)
                          )
                          : calculatePercentageAmount(
                            Number(offer_fixed_cash?.proposed_total),
                            Number(original_value)
                          )
                        : value;

                      return (
                        <div
                          key={id}
                          className="salary-offer__content-row__field"
                        >
                          <Input
                            type="text"
                            value={formatNumberWithCommas(
                              round(updatedVal! * currencyRate!) || ""
                            )}
                            readOnly
                            placeholder="Value here..."
                            size="large"
                          />
                        </div>
                      );
                    }
                  )}

                <div className="salary-offer__content-row__field--add-more" />
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row bg-revampLightBlueBackground rounded-l-md">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Total Bonus</label>
              </div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    offer_sti?.is_current_sale_incentive
                      ? offer_sti?.current_total_bonus
                      : current_bonus_target_amount || ""
                  )}
                  name="current_total_bonus"
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
                  <Input
                    value={formatNumberWithCommas(current_currency_total || "")}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row bg-revampLightBlueBackground rounded-r-md">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Total Bonus/Incentive</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    Math.round(
                      offer_sti?.is_sale_incentive &&
                        offer_fixed_cash?.proposed_annual_base &&
                        offer_sti.proposed_base_pay_percentage
                        ? (offer_fixed_cash.proposed_annual_base *
                          ((offer_fixed_cash.proposed_annual_base *
                            (100 - offer_sti.proposed_base_pay_percentage)) /
                            100)) /
                        ((offer_fixed_cash.proposed_annual_base *
                          offer_sti.proposed_base_pay_percentage) /
                          100) -
                        offer_sti.proposed_base_pay_percentage +
                        (offer_sti?.proposed_total_bonus || 0)
                        : offer_sti?.proposed_total_bonus || 0
                    )
                  )}
                  name="proposed_total_bonus"
                  placeholder="Value here..."
                  size="large"
                  type="text"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
                  <Input
                    value={
                      formatNumberWithCommas(
                        (
                          (currencyCode &&
                            offer_sti?.is_sale_incentive &&
                            offer_fixed_cash?.proposed_annual_base &&
                            offer_sti.proposed_base_pay_percentage
                            ? round(
                              (offer_fixed_cash.proposed_annual_base.toFixed() *
                                ((offer_fixed_cash.proposed_annual_base.toFixed() *
                                  (100 -
                                    offer_sti.proposed_base_pay_percentage.toFixed())) /
                                  100)) /
                              ((offer_fixed_cash.proposed_annual_base.toFixed() *
                                offer_sti.proposed_base_pay_percentage.toFixed()) /
                                100) -
                              offer_sti.proposed_base_pay_percentage.toFixed()
                            ) +
                            (offer_sti?.proposed_total_bonus?.toFixed() || 0)
                            : offer_sti?.proposed_total_bonus?.toFixed() || 0) *
                          currencyRate!
                        )?.toFixed(2)
                      ) || ""
                    }
                    readOnly
                    placeholder="Value here..."
                    size="large"
                    type="text"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
            </Col>
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Total Bonus Difference</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <div
                  className={`w-full px-6 text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue  py-2 rounded-md`}
                >
                  <div className="hidden">
                    {offer_sti?.proposed_total_bonus &&
                      offer_sti?.current_total_bonus
                      ? `${round(
                        ((offer_sti?.is_sale_incentive &&
                          offer_fixed_cash?.proposed_annual_base &&
                          offer_sti.proposed_base_pay_percentage
                          ? round(
                            (offer_fixed_cash.proposed_annual_base *
                              ((offer_fixed_cash.proposed_annual_base *
                                (100 -
                                  offer_sti.proposed_base_pay_percentage)) /
                                100)) /
                            ((offer_fixed_cash.proposed_annual_base *
                              offer_sti.proposed_base_pay_percentage) /
                              100) -
                            offer_sti.proposed_base_pay_percentage
                          ) + (offer_sti?.proposed_total_bonus || 0)
                          : offer_sti?.proposed_total_bonus || 0) /
                          offer_sti?.current_total_bonus -
                          1) *
                        100
                      )}%` || ""
                      : "0%"}
                  </div>
                  {`${totalBonusDifference?.toFixed(2)}%`}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row bg-revampLightBlueBackground rounded-l-md">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Target Total Cash</label>
              </div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    offer_fixed_cash?.current_total +
                    offer_sti?.current_total_bonus || ""
                  )}
                  name="current_total_bonus"
                  placeholder="Value here..."
                  size="large"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
                  <Input
                    value={formatNumberWithCommas(
                      Number(
                        (offer_fixed_cash?.current_total +
                          offer_sti?.current_total_bonus) *
                        currentCandidateCurrency!
                      )?.toFixed(2) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row bg-revampLightBlueBackground rounded-r-m">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Target Total Cash</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field">
                <Input
                  readOnly
                  value={formatNumberWithCommas(
                    Math.round(
                      offer_sti?.is_sale_incentive &&
                        offer_fixed_cash?.proposed_annual_base &&
                        offer_sti.proposed_base_pay_percentage
                        ? (offer_fixed_cash.proposed_annual_base *
                          ((offer_fixed_cash.proposed_annual_base *
                            (100 - offer_sti.proposed_base_pay_percentage)) /
                            100)) /
                        ((offer_fixed_cash.proposed_annual_base *
                          offer_sti.proposed_base_pay_percentage) /
                          100) -
                        offer_sti.proposed_base_pay_percentage +
                        ((offer_sti?.proposed_total_bonus || 0) +
                          (offer_fixed_cash?.proposed_total || 0))
                        : (offer_sti?.proposed_total_bonus || 0) +
                        (offer_fixed_cash?.proposed_total || 0)
                    )
                  )}
                  name="target_total_cash"
                  placeholder="Value here..."
                  size="large"
                />
              </div>
            </Col>

            {currencyCode ? (
              <Col className="salary-offer__content-row__col" span={7}>
                <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB ">
                  <Input
                    value={formatNumberWithCommas(
                      (
                        (offer_sti?.is_sale_incentive &&
                          offer_fixed_cash?.proposed_annual_base &&
                          offer_sti?.proposed_base_pay_percentage
                          ? round(
                            (offer_fixed_cash.proposed_annual_base *
                              ((offer_fixed_cash.proposed_annual_base *
                                (100 -
                                  offer_sti.proposed_base_pay_percentage)) /
                                100)) /
                            ((offer_fixed_cash.proposed_annual_base *
                              offer_sti.proposed_base_pay_percentage) /
                              100) -
                            offer_sti.proposed_base_pay_percentage
                          ) +
                          ((offer_sti?.proposed_total_bonus || 0) +
                            (offer_fixed_cash?.proposed_total || 0))
                          : (offer_sti?.proposed_total_bonus || 0) +
                          (offer_fixed_cash?.proposed_total || 0)) *
                        currencyRate!
                      )?.toFixed(2) || ""
                    )}
                    readOnly
                    placeholder="Value here..."
                    size="large"
                  />
                </div>
              </Col>
            ) : null}
          </Row>
        </Col>
      </Row>

      <Row className="salary-offer">
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
            </Col>
            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB"></div>
            </Col>
          </Row>
        </Col>
        <Col className="salary-offer__parent-col" span={12}>
          <Row className="salary-offer__content-row">
            <Col className="salary-offer__content-row__col" span={labelColSpan}>
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <label>Target Cash Difference</label>
              </div>
            </Col>

            <Col
              className="salary-offer__content-row__col"
              span={currencyCode ? 14 : currencyColSpan}
            >
              <div className="salary-offer__content-row__field salary-offer__content-row__field--totalBB">
                <div
                  className={`w-full px-6 text-white shadow-md my-2 font-semibold text-center text-sm outline-none border border-themeInputBorder bg-revampBlue py-2 rounded-md`}
                >
                  <div className="hidden">
                    {(
                      ((offer_sti?.is_sale_incentive &&
                        offer_fixed_cash?.proposed_annual_base &&
                        offer_sti?.proposed_base_pay_percentage
                        ? round(
                          (offer_fixed_cash.proposed_annual_base *
                            ((offer_fixed_cash.proposed_annual_base *
                              (100 -
                                offer_sti.proposed_base_pay_percentage)) /
                              100)) /
                          ((offer_fixed_cash.proposed_annual_base *
                            offer_sti.proposed_base_pay_percentage) /
                            100) -
                          offer_sti.proposed_base_pay_percentage
                        ) +
                        ((offer_sti?.proposed_total_bonus || 0) +
                          (offer_fixed_cash?.proposed_total || 0))
                        : (offer_sti?.proposed_total_bonus || 0) +
                        (offer_fixed_cash?.proposed_total || 0)) /
                        (offer_fixed_cash?.current_total +
                          offer_sti?.current_total_bonus) -
                        1) *
                      100
                    ).toFixed(2)}
                    %
                  </div>

                  {`${targetCashDifference?.toFixed(2)}%`}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ShortTermIncentives;
